module.exports = __webpack_public_path__ + "static/media/RenewableGreenEnergyblue.a71ba8f9.svg";